import format from 'date-fns-old/format';
import slice from 'lodash/slice';
import moment from 'moment';

import differenceInYears from 'date-fns-old/difference_in_years';
import { DAY_FORMATTING_PATTERN } from '../constants/strings';
import { convertDateToAPIFormat } from './converters/dateConverters';

const CURRENT_YEAR = moment().format('YYYY');
const CURRENT_MONTH = moment().format('MM');

const handleDOB = (date, formatMessage) => {
  // Safari bug - new Date does not work with UI format
  const apiDate = convertDateToAPIFormat(date, formatMessage);
  const age = handleAge(date, formatMessage);
  const dob = format(apiDate, formatMessage(DAY_FORMATTING_PATTERN));

  return `${dob} (${age})`;
};

export function handleAge(date, formatMessage) {
  const apiDate = convertDateToAPIFormat(date, formatMessage);
  const age = differenceInYears(new Date(), apiDate);

  return `${age} ${formatMessage({ id: 'general.labels.YO' })}`;
}

export default handleDOB;

export function getYearsInRange(start, end) {
  const currentYear = end || moment().get('year');
  const years = Array(currentYear - start + 1)
    .fill()
    .map((_, idx) => start + idx);
  return years.map(item => {
    return {
      value: moment()
        .year(item)
        .format('YYYY'),
      label: moment()
        .year(item)
        .format('YYYY'),
    };
  });
}

export function getDaysOfMonth(year, month) {
  const dayCount = moment(`${year}-${month}`, 'YYYY-MM').daysInMonth();

  const days = [];
  Array.from({ length: dayCount }, (index, value) =>
    days.push({
      value: moment(`${year}-${month}-${value + 1}`, 'YYYY-MM-DD').format('DD'),
      label: moment(`${year}-${month}-${value + 1}`, 'YYYY-MM-DD').format('DD'),
    }),
  );

  if (year === CURRENT_YEAR && month === CURRENT_MONTH) {
    return slice(days, 0, moment().get('date'));
  }

  return days;
}

export function getMonths(year) {
  const months = moment.months();

  const formattedMonths = months.map(item => {
    return {
      value: moment()
        .month(item)
        .format('MM'),
      label: item,
    };
  });

  if (year === CURRENT_YEAR) {
    return slice(formattedMonths, 0, moment().get('month') + 1);
  }

  return formattedMonths;
}



// WEBPACK FOOTER //
// ./src/utils/handleDOB.js